/* External dependencies */
import { Div } from 'atomize';
import { Link } from 'gatsby-plugin-react-i18next';
import React from 'react';

/*Local dependencies */
import './style.scss';

interface DropdownProps {
  activeClass?: any;
  items: any;
  onClick?: () => void;
}

export default function Dropdown(props: DropdownProps) {
  const { activeClass, items, onClick } = props;

  const linkStyle = {
    color: 'rgba(69, 103, 167, 0.6)',
    cursor: 'pointer',
    display: 'block',
    fontSize: '1rem',
    fontWeight: '400',
    textDecoration: 'none',
  };

  return (
    <Div
      bg="bg_dropdown"
      h="auto"
      p="1rem"
      rounded="5px"
      className={`dropdown ${activeClass}`}
      pos="absolute"
      top="auto"
      b="0"
      textAlign="left"
      m={{ t: '20px' }}
    >
      {items.map((item, index) => (
        <Link
          key={index}
          to={item.originalPath}
          language={item.lang}
          style={linkStyle}
          activeStyle={{ color: '#4567A7' }}
        >
          {item.name}
        </Link>
      ))}
    </Div>
  );
}
